var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader8Shape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1921.8 211.91c-173.36-31.81-350.84-40.49-525.77-20.27-191 22.08-372.12 92.53-550.91 159.54C569 454.67 296.84 521.03.89 491.64c0 0-.33-212.35-.33-259.98V0h1918.16c-.14 70.71.49 141.39 3.08 211.91z",
    fill: "#e3e7f0",
    opacity: 0.4
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZTNlN2YwO29wYWNpdHk6LjQ7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE5MjEuOCwyMTEuOTFjLTE3My4zNi0zMS44MS0zNTAuODQtNDAuNDktNTI1Ljc3LTIwLjI3LTE5MSwyMi4wOC0zNzIuMTIsOTIuNTMtNTUwLjkxLDE1OS41NEM1NjksNDU0LjY3LDI5Ni44NCw1MjEuMDMsLjg5LDQ5MS42NGMwLDAtLjMzLTIxMi4zNS0uMzMtMjU5Ljk4VjBIMTkxOC43MmMtLjE0LDcwLjcxLC40OSwxNDEuMzksMy4wOCwyMTEuOTFaIi8+PC9zdmc+";
export { SvgHeader8Shape as ReactComponent };